"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallDetailsContainer = exports.CallDetailsIcon = exports.CallDetailsIconWrapper = exports.CloseButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_react_1 = require("@streem/ui-react");
const CloseButton = (props) => ((0, jsx_runtime_1.jsx)(ui_react_1.Box, Object.assign({ style: {
        position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        right: `28px`,
        top: `28px`,
    } }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.IconButton, { iconName: "CloseIcon", size: "medium", shape: "circle", label: "close", onClick: props.onClick, background: "azure", fill: "white", "data-testid": props.id, type: "button" }) })));
exports.CloseButton = CloseButton;
exports.CallDetailsIconWrapper = ui_react_1.styled.div((props) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: props.width,
    height: '40px',
}));
exports.CallDetailsIcon = (0, ui_react_1.styled)(ui_react_1.AppIcon)(() => ({
    transform: 'scale(0.9)',
    flexShrink: 0,
}));
exports.CallDetailsContainer = ui_react_1.styled.div(() => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '40px',
    lineHeight: '40px',
}));
//# sourceMappingURL=tool_styles.js.map